import {
  CalendarType,
  VisitCardLineStyleDto,
  VisitCardSettingsDto,
} from '@lmt/shared-types';
import i18next from 'i18next';
import * as yup from 'yup';

function t(value: string, options?: any) {
  return i18next.t(`translation:errors.${value}` as any, options);
}

export const expressionErrorString = 'Error in expression ';

export const visitCardSettingsYupSchema: yup.Schema<
  Partial<VisitCardSettingsDto>
> = yup.object({
  weekLineStyles: yup.array().of(
    yup
      .object()
      .shape({
        position: yup.number().required(),
        expression: yup.string().required(() => t('required')),
        fontSize: yup
          .number()
          .required(() => t('required'))
          .typeError(() => t('incorrect'))
          .max(36, () => t('max_number', { maxNumber: 36 }))
          .min(10, () => t('min_number', { minNumber: 10 })),
        paddingTop: yup
          .number()
          .required(() => t('required'))
          .typeError(() => t('incorrect'))
          .max(40, () => t('max_number', { maxNumber: 40 }))
          .min(2, () => t('min_number', { minNumber: 2 })),
        isBold: yup.boolean().required(() => t('required')),
      })
      .defined(),
  ),
  dayLineStyles: yup.array().of(
    yup
      .object()
      .shape({
        position: yup.number().required(),
        expression: yup.string().required(() => t('required')),
        fontSize: yup
          .number()
          .required(() => t('required'))
          .typeError(() => t('incorrect'))
          .max(36, () => t('max_number', { maxNumber: 36 }))
          .min(10, () => t('min_number', { minNumber: 10 })),
        paddingTop: yup
          .number()
          .required(() => t('required'))
          .typeError(() => t('incorrect'))
          .max(40, () => t('max_number', { maxNumber: 40 }))
          .min(2, () => t('min_number', { minNumber: 2 })),
        isBold: yup.boolean().required(() => t('required')),
      })
      .defined(),
  ),
  monthLineStyles: yup.array().of(
    yup
      .object()
      .shape({
        position: yup.number().required(),
        expression: yup.string().required(() => t('required')),
        fontSize: yup
          .number()
          .required(() => t('required'))
          .typeError(() => t('incorrect'))
          .max(36, () => t('max_number', { maxNumber: 36 }))
          .min(10, () => t('min_number', { minNumber: 10 })),
        paddingTop: yup
          .number()
          .required(() => t('required'))
          .typeError(() => t('incorrect'))
          .max(40, () => t('max_number', { maxNumber: 40 }))
          .min(2, () => t('min_number', { minNumber: 2 })),
        isBold: yup.boolean().required(() => t('required')),
      })
      .defined(),
  ),
});

export const lineStylesYupSchema: yup.Schema<Partial<VisitCardLineStyleDto>> =
  yup.object({
    position: yup.number().required(),
    expression: yup.string().required(() => t('required')),
    fontSize: yup
      .number()
      .required(() => t('required'))
      .typeError(() => t('incorrect'))
      .max(36, () => t('max_number', { maxNumber: 36 }))
      .min(10, () => t('min_number', { minNumber: 10 })),
    paddingTop: yup
      .number()
      .required(() => t('required'))
      .typeError(() => t('incorrect'))
      .max(40, () => t('max_number', { maxNumber: 40 }))
      .min(2, () => t('min_number', { minNumber: 2 })),
    isBold: yup.boolean(),
  });

export function getVisitCardStylesForCalendarType(
  calendarType: CalendarType,
  settings?: VisitCardSettingsDto,
): VisitCardLineStyleDto[] {
  switch (calendarType) {
    case CalendarType.Day:
      return settings?.dayLineStyles ?? [];
    case CalendarType.Week:
      return settings?.weekLineStyles ?? [];
    case CalendarType.Month:
      return settings?.monthLineStyles ?? [];
    default:
      return [];
  }
}
